import React from "react";
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";
import { getEventValue } from "../../services/forms.service";
import { createMap, addSearch, addBubble } from "../../services/maps.service";

export default class Map extends Subscriber {
  timer;
  map = null;
  marker = null;
  mapConfig;

  using_current_location = true;

  state = {
    fetchingCurrentPosition: true,
    search_enabled: false,
    clearVisible: false,
    searchValue: "",
  };

  constructor(props) {
    super(props);
    if (this.props && this.props.ref) {
      this.mapRef = this.props.ref;
    } else {
      this.mapRef = React.createRef();
    }
    this.searchRef = React.createRef();
  }

  renderMap = () => {
    if (this.props.id && this.mapRef.current) {
      let map = createMap(this.props.id, this.mapRef, this.props);
      if (map) {
        if (!this.props.freeze && this.searchRef.current) {
          addSearch(this.searchRef, this.props.id, true);
        }
        if (this.props.bubble) {
          addBubble(this.props.id, this.props.bubble);
        }
      }
    }
  };

  componentDidMount() {
    window.mapLoaded = () => {};
    this.subscriptions.push(
      Storage.get_obsrv("maps_loaded").subscribe((data) => {
        if (data && this.mapRef.current) {
          this.renderMap();
        }
      })
    );
    this.subscriptions.push(
      Storage.get_obsrv("coverage_map_formatted_address").subscribe((data) => {
        if (data && this.mapRef.current) {
          this.setState({
            	searchValue: data,
            });
        }
      })
    );
  }
  shouldComponentUpdate(nextState, nextProp) {
    if (this.state.searchValue !== nextState.searchValue || 
        this.props.disableBtn !== nextProp.disableBtn ||
        this.props.bubble !== nextProp.bubble
      ) {
      return true;
    }
    return false;
  }
  change = (event) => {
    let val = getEventValue(event);
    this.setState({
      clearVisible: val ? true : false,
    });
  };

  clear = () => {
    this.props.clearLocation();
    this.props.disableBtn('disabled')
    Storage.clear("coverage_map_formatted_address");
    this.searchRef.current.value = null;
    this.setState({
      clearVisible: false,
      searchValue: "",
    });
  };

  render() {
    let map = (
      <div className={`vmo-map ${this.props.coverageCheckConfirm ? "coverageCheckConfirm" : ''}`} ref={this.mapRef} id={this.props.id}>
        Loading map...
      </div>
    );

    let predictions_html_for_map = [];

    let autoCompleteList = [];

    let map_search_wrapper = "";

    let map_search = (
      <div
        className={
          autoCompleteList && autoCompleteList.length > 0
            ? "with-autocomplete"
            : ""
        }>
        <input
          autoComplete="off"
          placeholder={"Search for location"}
          type="text"
          ref={this.searchRef}
          id="map_search_box"
          value={
            this.state.searchValue
              ? this.state.searchValue
              : Storage.get("coverage_map_formatted_address") ? Storage.get("coverage_map_formatted_address") : ""
          }
          onChange={(event) => {
            this.setState({
            	searchValue: getEventValue(event),
            });
          }}
          onFocus={() => {
            // this.setState({
            //   address_search_visible: true,
            // });
          }}
          onClick={() => {
            //Events.clicks_on_delivery_form_map_address_field();
          }}
          onBlur={() => {
            // this.addressBlurred();
          }}
          // className={
          //   "form-txt " +
          //   (this.state.form.fields_validity.delivery_address
          //     ? "valid"
          //     : "invalid") +
          //   (this.state.form.delivery_address.value ? " filled" : "")
          // }
          name="delivery_address"
        />
        <div
          className={
            "vmo-address-field-suggestions " +
            (autoCompleteList && autoCompleteList.length > 0 ? "visi" : "")
          }>
          {predictions_html_for_map}
        </div>
        {this.state.clearVisible ||
        Storage.get("coverage_map_formatted_address") ? (
          <div className="vmo-field-clear" onClick={this.clear} />
        ) : (
          ""
        )}
      </div>
    );

    if (this.props.map_search) {
      map_search = this.props.map_search;
    }

    if (!this.props.disable_search) {
      map_search_wrapper = (
        <div id="map_search" className="vmo-map-search">
          <div className="vmo-map-searchbox">
            <div
              className="vmo-map-searchbox-inner"
              onChange={(event) => {
                this.change(event);
              }}>
              {map_search ? (
                map_search
              ) : (
                <>
                  <div className="vmo-map-searchbox-inner-2">
                    <input
                      type="text"
                      id="map_search_box"
                      ref={this.searchRef}
                      placeholder="Search.."
                      onFocus={() => {
                        // Events.clicks_on_delivery_map_search_field();
                      }}
                    />
                  </div>
                  {this.state.clearVisible ? (
                    <div className="vmo-field-clear" onClick={this.clear} />
                  ) : (
                    ""
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      );
    }

    let classes = [];
    if (!this.props.disable_search) {
      classes.push("vmo-map-search-at-top");
    }
    if (this.props.size) {
      classes.push("vmo-map-size-" + this.props.size);
    }

    return (
      <div className="vmo-map-wrapper">
        <div className={"vmo-map-wrapper-area " + classes.join()}>
          {map}
          {map_search_wrapper}
        </div>
      </div>
    );
  }
}
